var ChangeAvatarModule = /** @class */ (function () {
    function ChangeAvatarModule() {
    }
    return ChangeAvatarModule;
}());
export { ChangeAvatarModule };
